// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__olo39","header":"Dashboard_header__l2V5s","grid":"Dashboard_grid__5lw9p","card":"Dashboard_card__kvQ3w","icon":"Dashboard_icon__I-ZGw"};